import { Outlet, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function SiteLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />

      {/* Mobile floating back-home */}
      <Link
        to="/"
        aria-label="返回首页"
        className="md:hidden fixed bottom-5 right-5 z-40 w-12 h-12 rounded-full bg-primary-500 text-foreground-950 shadow-lg flex items-center justify-center active:scale-95 transition-transform"
      >
        <i className="ri-home-4-line text-xl" />
      </Link>
    </div>
  );
}